<template>
  <NuxtPage />
</template>

<script>
export default {
  name: 'Empty',
}
</script>
